import { DWSCanceledController } from './canceled.controller';
import template from './canceled.html';

export const dwsCanceledComponent = {
  name: 'dwsCanceledComponent',
  restrict: 'E',
  template,
  controller: DWSCanceledController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<',
  },
};
